import React, {Component} from 'react';
import {Row, Col} from 'reactstrap';
import {List, ListItem, Typography, Divider} from '@material-ui/core';
import { connect } from 'react-redux';
import { fetchMuestraModal, fetchCambiaStatoModalAcciones,fetchCambiaStadoModal } from './../../actions/interfaz/index'
import { fetchIdAccion } from './../../actions/usuarios/index'
import { withLocalize, Translate } from 'react-localize-redux';
import AccionesTranslations from './../../traducciones/Actions.json';

import './styles.css';

/* md Libro incidencias no hace falta
const acciones =[
    {Id:1,nombre:'Modificar datos expediente'},
    {Id:2,nombre:'Tramitar nuevo trabajo'},
    {Id:3,nombre:'Solicitar Loa(libro de órdenes y asistencias)'},
    {Id:4,nombre:'Solicitar Li(libro de incidencias)'},
    {Id:5,nombre:'convertir a digital expediente papel'},
    {Id:6,nombre:'cesar/cerrar expediente'}
];*/

const acciones =[
    {Id:1,nombre:'Modificar datos expediente'},
    {Id:2,nombre:'Tramitar nuevo trabajo'},
    {Id:3,nombre:'Solicitar Loa(libro de órdenes y asistencias)'},        
    {Id:5,nombre:'Adaptar expediente a la guía de tramitación'},    
    {Id:4,nombre:'Convertir expediente papel a digital'},    
    {Id:6,nombre:'Cesar/cerrar expediente'}    
];



class AccionesExistentes extends Component { 
    constructor(props) {
        super(props);
        this.props.addTranslation(AccionesTranslations);
      }

      handleClick(accion){
          this.props.fetchIdAccion(accion.Id);
          this.props.fetchMuestraModal(accion.Id);
          this.props.fetchCambiaStatoModalAcciones();
          this.props.fetchCambiaStadoModal();
      }



    render() {
        let {classes} = this.props;
        return (
            <div>
            <Row>
                <Col>
             
                    <List component="nav"
                    subheader={<Typography variant="h6" gutterBottom className="px-4 pt-4 pb-1 mx-0" style={{fontSize: 18}}>
                                <Translate id="Actions.title"/>
                            </Typography>}>
                        <Divider/>
                        {
                            acciones.map((accion,i) => (
                                <ListItem key={i} onClick={() => {this.handleClick(accion)}} button className={"border-bottom-accionesexistentes"/*classes.borderBottom*/}>
                                    <Typography variant="button" gutterBottom color="primary" className="mb-1 mt-1 mx-0">
                                        {this.props.translate(`Actions.listactions.action${accion.Id-1}`)}
                                    </Typography>
                                    <Divider/>
                                </ListItem>
                            ))
                        }
                    </List>


                   {/* <List component="nav0"
                    subheader={<Typography variant="h6" gutterBottom className="px-4 pt-4 pb-3" style={{fontSize: 18}}>
                    Otras acciones
                </Typography>}>
                        <Divider/>
                      
                      
                                <ListItem onClick={() => {this.handleClickGuia()}} button className={classes.borderBottom}>
                                    <Typography variant="button" gutterBottom color="primary" className="mb-1 mt-1">
                                     Consultar guía de tramitación-traballos disponibles
                                    </Typography>
                                    <Divider/>
                                </ListItem>
                            
                      
                    </List>*/}

                </Col>
            </Row>
            </div>

        );
    }
}


const mapStateToProps = state => ({
  
  });
export default connect(mapStateToProps,{ fetchMuestraModal, fetchIdAccion, fetchCambiaStatoModalAcciones,fetchCambiaStadoModal })(withLocalize(AccionesExistentes))



